module.exports = __webpack_public_path__ + "img/card-7.326eb72e.png";